import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      gap: theme.spacing(5),
    },
  },
  adContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4),
  },
  loadPreviousButton: {
    margin: "0 auto",
  },
}));
